import { render, staticRenderFns } from "./price-desc.vue?vue&type=template&id=40284dfe&scoped=true&"
import script from "./price-desc.vue?vue&type=script&lang=js&"
export * from "./price-desc.vue?vue&type=script&lang=js&"
import style0 from "./price-desc.vue?vue&type=style&index=0&id=40284dfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40284dfe",
  null
  
)

export default component.exports